import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { DisputeRoutingRule } from '@dill/dill-shared';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { DisputeRoutingRuleInitialState } from '../globalSlices/disputeRoutingRuleSlice';
import {
  getSupplierDisputeRoutingRules,
  createDisputeRoutingRule,
  updateDisputeRoutingRule,
  deleteDisputeRoutingRule,
} from '../services/disputeRoutingRuleService';

export const getSupplierDisputeRoutingRulesExtraReducer = (
  builder: ActionReducerMapBuilder<DisputeRoutingRuleInitialState>
) => {
  const reducerId = 'getSupplierDisputeRoutingRules';
  builder.addCase(getSupplierDisputeRoutingRules.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierDisputeRoutingRules.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.rules = action.payload.data as DisputeRoutingRule[];
      }
    }
  );
  builder.addCase(getSupplierDisputeRoutingRules.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const createDisputeRoutingRuleExtraReducer = (
  builder: ActionReducerMapBuilder<DisputeRoutingRuleInitialState>
) => {
  const reducerId = 'createDisputeRoutingRule';
  builder.addCase(createDisputeRoutingRule.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createDisputeRoutingRule.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.rules = [action.payload.data as DisputeRoutingRule, ...state.rules];
      }
    }
  );
  builder.addCase(createDisputeRoutingRule.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const updateDisputeRoutingRuleExtraReducer = (
  builder: ActionReducerMapBuilder<DisputeRoutingRuleInitialState>
) => {
  const reducerId = 'updateDisputeRoutingRule';
  builder.addCase(updateDisputeRoutingRule.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(updateDisputeRoutingRule.fulfilled, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(updateDisputeRoutingRule.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deleteDisputeRoutingRuleExtraReducer = (
  builder: ActionReducerMapBuilder<DisputeRoutingRuleInitialState>
) => {
  const reducerId = 'deleteDisputeRoutingRule';
  builder.addCase(deleteDisputeRoutingRule.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(deleteDisputeRoutingRule.fulfilled, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(deleteDisputeRoutingRule.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
